module.exports = __webpack_public_path__ + "img/IconoPlayeras.ce359877.png";